import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine4 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#A0006E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2908 15.9342V13.8697H14.6578V5.44148H11.279L6.13623 13.4752V15.9342H12.1049V18.6934H14.6578V15.9342H16.2908ZM12.1049 13.8697H8.40736L11.1102 9.6274C11.6359 8.80148 12.0113 7.99435 12.0676 7.76922H12.1049V13.8697Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLine4);
export { ForwardRef as ReactComponent };
